import { SMARTY_US_AUTOCOMPLETE_KEY } from '../utils/smartyConfig';
import useSmartyLookupBase from './useSmartyLookupBase';

const MIN_QUERY_LENGTH = 3;
const CACHE_NAMESPACE = 'smarty-us-autocomplete';
const CACHE_TTL_MS = 60 * 1000;
const RATE_LIMIT_NAMESPACE = 'smarty-us-autocomplete';
const RATE_LIMIT_CONFIG = {
  limit: 15,
  windowMs: 60 * 1000,
  cooldownMs: 30 * 1000
};
const RATE_LIMIT_MESSAGE = 'Too many requests. Please wait a moment and try again.';

const buildCacheKey = (trimmedQuery, selectedAddress) => JSON.stringify({
  query: trimmedQuery,
  selected: selectedAddress ? {
    streetLine: selectedAddress.street_line,
    secondary: selectedAddress.secondary,
    entries: selectedAddress.entries,
    city: selectedAddress.city,
    region: selectedAddress.state,
    postalCode: selectedAddress.zipcode
  } : null
});

const buildLookupUrl = (trimmedQuery, selectedAddress) => {
  let smartyUrl = 'https://us-autocomplete-pro.api.smarty.com/' +
    `lookup?key=${SMARTY_US_AUTOCOMPLETE_KEY}&search=${encodeURIComponent(trimmedQuery)}`;

  if (selectedAddress) {
    const selectedParam = `${selectedAddress.street_line} ` +
      `${selectedAddress.secondary} (${selectedAddress.entries}) ` +
      `${selectedAddress.city} ${selectedAddress.state} ${selectedAddress.zipcode}`;
    smartyUrl += `&selected=${encodeURIComponent(selectedParam)}`;
  }

  return smartyUrl;
};

const transformSuggestions = (responseData = {}) => {
  const results = responseData.suggestions || [];

  return results.map((result) => {
    let whiteSpace = '';
    let secondary = result.secondary || '';

    if (secondary) {
      if (result.entries > 1) {
        secondary += ` (${result.entries} entries)`;
      }
      whiteSpace = ' ';
    }

    const displayText = `${result.street_line}${whiteSpace}${secondary} ${result.city}, ${result.state} ${result.zipcode}`;

    return {
      ...result,
      displayText
    };
  });
};

const useSmartyUSLookup = (query, selectedAddress = null, debounceMs = 300) => {
  const trimmedQuery = query.trim();
  const isEnabled = Boolean(trimmedQuery && (selectedAddress || trimmedQuery.length >= MIN_QUERY_LENGTH));
  const cacheKey = buildCacheKey(trimmedQuery, selectedAddress);
  const requestUrl = isEnabled ? buildLookupUrl(trimmedQuery, selectedAddress) : '';

  return useSmartyLookupBase({
    isEnabled,
    debounceMs,
    cacheNamespace: CACHE_NAMESPACE,
    cacheTtlMs: CACHE_TTL_MS,
    rateLimitNamespace: RATE_LIMIT_NAMESPACE,
    rateLimitConfig: RATE_LIMIT_CONFIG,
    cacheKey,
    requestUrl,
    transformResponse: transformSuggestions,
    onError: (err) => {
      console.error('Smarty US lookup failed:', err);
    },
    effectDeps: [query, selectedAddress]
  });
};

export default useSmartyUSLookup;
